import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=533ca2c3&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=533ca2c3&scoped=true&lang=css&"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ca2c3",
  null
  
)

export default component.exports